export const GET_TEAM_INFO = 'GET_TEAM_INFO';
export const GET_TEAM_MEMBERS = 'GET_TEAM_MEMBERS';
export const SET_PLAYERS_FROM_MATCH = "SET_PLAYERS_FROM_MATCH"

